import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          withCredentials: true,
        });
        setUser(data);
        sessionStorage.setItem("athanor_splash", "video");
        window.location.replace("/");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0b0b0c]">
      <div className="text-sm text-slate-400">Accesso in corso...</div>
    </div>
  );
}
